import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Button } from '@/components/ui/button';
export function LoginToast() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="font-bold">Login required</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div>Please log in to mark words.</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex w-full flex-col gap-1">{t0}<div className="flex flex-row justify-between">{t1}<div className="flex items-end"><Button variant="outline" className="p-0 text-xs whitespace-nowrap" size="sm"><Link href="/login" className="flex size-full items-center px-3">Sign in</Link></Button></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}